module.exports = __webpack_public_path__ + "img/radar_off.aa1d29d2.svg";